import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Container, Button, Label } from "reactstrap"
import MetaTags from "react-meta-tags"
import { AvForm, AvField } from 'availity-reactstrap-validation'
import Select from "react-select"
import Language from "Enums/Language"
import SelectOptions from "components/SelectOptions"
import UnitTypesService from "services/Admin/UnitTypesService"
import { SuccessCreated, SuccessOk } from "configs/statusCode"
import { toast } from "react-toastify"
import { adminPrefix } from "configs/routePrefix"
import CompoundService from "services/Admin/CompoundService"
import PaymentPlanService from "services/Admin/PaymentPlanService"
import SuccessModal from "components/SucessModal"
import CancelModal from "components/CancelModal"
import { frequencyPropertyOptions, installment_type, type_of_paid_options } from "Enums/fixedData"
import CurrencyInput from "react-currency-input-field"
import { useSelector } from "react-redux"
import AppoinmentsSvg from "assets/images/appoinments.svg"

const initialState = {
    en: "",
    ar: "",
    ru: "",
    zh: "",
    selectUnitType: [],
    years: [{
        depost: "",
        years: "",
        down_payment: "",
        recurring_payments: [
            {
                payment_frequency: null,
                payment_amount: [""]
            }
        ],
        off_payments: [],
        link_down_payment: false,
        type: ''
    }],
    elevate_down_payment: [
        {down_payment: "", discount: ''}
    ],
}

const AddPayment = (props) => {
    const filterData = useSelector(state => state.adminFilter)
    const [loading, setLoading] = useState(false)
    const id = props.match.params.id
    const [formData, setFormData] = useState({
        ...initialState
    })

    const [CompoundOpttions, setCompoundpttions] = useState([])
    const [compoundIds, setCompoundIds] = useState([])
    const [unitTypeOptions, setUnitTypeOptions] = useState([])
    const [modal, setModal] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const paymentPlanService = new PaymentPlanService()
    const unitSizeService = new UnitTypesService()
    const [anotherOffPayment, setAnotherOffPayment] = useState({})

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const hasPaymentfrequency = () => {
        let value = false
        formData.years.forEach(year => {
            return year.recurring_payments.forEach(recurringItem => {
                if (!recurringItem.payment_frequency) {
                    value = true
                }
            })
        })
        return value
    }

    useEffect(()=>{
        if(!!filterData.compound_id) setCompoundIds([...compoundIds, filterData.compound_id])
    },[])

    useEffect(()=>{
       if(compoundIds?.length > 0){
        unitSizeService.getUnitTypesDropDown(compoundIds).then(res=>{
            let options = []
            res?.data?.map(item => {
                options.push({label: item?.name?.en, value: item?.id, ...item?.name})
            })
            setUnitTypeOptions([...options])
        })
       }else{
        setUnitTypeOptions([])
       }
    },[compoundIds])

    const handleValidSubmit = () => {
        // if (formData.years.length > 0) {
        //     formData.years?.map((year, index)=>{
        //         if(!year?.depost){
        //             setError((prev)=> ({...prev, [index]: {...error[index], depost:true}}))
        //         }
        //     })
        // }
        if (hasPaymentfrequency()) {
            return toast.error("Please select Payment Frequency")
        } 
        if (formData.selectedCompound?.length === 0) {
            return toast.error("Please Select Compound")
        }
        if (formData.selectUnitType.length === 0) {
            return toast.error("Please Select Unit Type")
        }
        if (formData.currency?.length === 0) {
            return toast.error("Please Select Currency")
        }
        else {
            setLoading(true)
            let years = formData.years?.filter(item=> !!item?.type?.value)?.map((item) => ({
                    ...item,
                    recurring_payments: item?.recurring_payments?.filter(res=> !!res?.payment_frequency),
                    type: item?.type?.value,
                    off_payments: !!item.off_payments?.length ? [
                      ...item.off_payments,
                      ...item.off_payments?.flatMap((offPayment) =>
                        !!offPayment?.another?.length ? offPayment.another?.map((anotherItem) => ({
                          payment_name: offPayment.payment_name,
                          type: offPayment?.type,
                          ...anotherItem
                        })) : []
                      ),
                    ].filter(item => Object.keys(item).length !== 0)?.map(payment => {
                        const { another, ...rest } = payment;
                        return rest;
                    }) : [],
                  }));
            const data = {
                name: {
                    en: formData.en,
                    ar: formData.ar,
                    ru: formData.ru,
                    zh: formData.zh
                },
                compounds: formData.selectedCompound?.map(compound => compound.value),
                unit_types: formData.selectUnitType.map(item => item.value),
                elevate_down_payment: formData.elevate_down_payment?.map(item=>{
                    return {
                        down_payment: Number(item?.down_payment),
                        discount: Number(item?.discount),
                    }
                }),
                years: years,
            }

            if (id) {
                paymentPlanService.update(id, data).then(res => {
                    if (res && res.status === SuccessOk) {
                        setLoading(false)
                        setSuccessModal(true)
                    } else {
                        setLoading(false)
                    }
                })
            } else{
                paymentPlanService.create(data).then(res => {
                    if (res && res.status === SuccessCreated) {
                        setLoading(false)
                        // setFormData((formData) => ({ ...formData, ...initialState, years: [] }))
                        setSuccessModal(true)
                    } else {
                        setLoading(false)
                    }
                })
            }
        }
    }

    useEffect(() => {
        if (id) {
            paymentPlanService.find(id).then(res => {
                if (res && res.status === SuccessOk) {
                    const unitesTypes = res.data.unit_types.map(item => ({
                        label: item.name.en,
                        value: item.id
                    }))
                    let compoundsIds = res.data.compounds.map(compound => {
                        return {
                            value: compound.id,
                            label: compound.name.en
                        }
                    })
                    let another = {}
                    let years = res.data.years?.map((yearItem, yearIndex)=>{
                        const duplicates = [];
                        const unique = yearItem?.off_payments?.filter((obj, index, self) => {
                            const isDuplicate = index !== self.findIndex((t) =>(t.payment_name === obj.payment_name))
                            if (isDuplicate){
                                duplicates.push(obj)
                            }
                            another[index] = duplicates
                            
                            return !isDuplicate;
                        })
                        let result = unique?.map((item,intemIndex) =>{
                            let filtered = duplicates?.filter(obj=> obj.payment_name == item.payment_name)
                            return{
                                another: [...filtered],
                                ...item
                            }
                        })
                        
                        return {
                            ...yearItem,
                            type: installment_type?.find(opt => opt?.value === yearItem?.type),
                            off_payments: result
                        }
                    })
                    setAnotherOffPayment(another)
                    
                    setFormData({
                        ...formData,
                        en: res.data.name.en,
                        ar: res.data.name.ar,
                        ru: res.data.name.ru,
                        zh: res.data.name.zh,
                        selectUnitType: [...unitesTypes],
                        years: years,
                        selectedCompound: compoundsIds,
                        elevate_down_payment: res.data?.elevate_down_payment,
                    })
                    let ids = compoundsIds.map(item => {
                        return item.value
                    } )
                    setCompoundIds(ids)
                }
            })
        } else {
            setFormData({
                en: "",
                ar: "",
                ru: "",
                zh: "",
                selectUnitType: [],
                years: [{
                    years: "",
                    depost: "",
                    down_payment: "",
                    recurring_payments: [
                        {
                            payment_frequency: null,
                            payment_amount: [""]
                        }
                    ],
                    off_payments: [],
                    link_down_payment: false,
                    type: ""
                }],
                elevate_down_payment: [
                    {down_payment: "", discount: ''}
                ],
                cash: '',
                discount: '',
                selectedCompound: !!filterData?.compound ? [filterData?.compound] : []
            })
        }
    }, [])

    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>{id ? "Edit Payment Plan" : "Add New Payment Plan"}</title>
                </MetaTags>
                <Container fluid>
                    <h4>{id ? "Edit Payment Plan" : "Add New Payment Plan"}</h4>
                    <AvForm className='form-horizontal'
                        onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
                        <Card >
                            <CardBody>
                                <Row>
                                    {Language.LIST.map((lan, index) => {
                                        return (
                                            <Col md={6} key={index} >
                                                <AvField
                                                    className="mb-3"
                                                    name={lan.name}
                                                    label={`Payment Plan Name (${lan.name})${lan.name === "en" ? "*" : ""}`}
                                                    
                                                    value={formData[`${lan.name}`]}
                                                    onChange={e => handleFieldChange(e)}
                                                    required={lan.name === "en" ? true : false}
                                                    errorMessage="This field is required"
                                                    placeholder={lan.name === "en" ? 'English' : lan.name === "ar" ? "العربية" : lan.name === "zh" ? "中文" : "Русский"}
                                                />
                                            </Col>
                                        )
                                    })}
                                    <Col md={6}>
                                        <SelectOptions
                                            label='Compound*'
                                            placeholder='Select'
                                            options={CompoundOpttions}
                                            handleSelectChange={data => {
                                                if(data?.length > 0){
                                                    let ids= data?.map(item => item?.value)
                                                    setCompoundIds(ids)
                                                    setFormData({ ...formData, selectedCompound: data })
                                                } else{
                                                    setCompoundIds([])
                                                    setFormData({ ...formData, selectUnitType: [], selectedCompound: data })
                                                }
                                            }}
                                            selectedOption={formData.selectedCompound}
                                            Service={CompoundService}
                                            setOptions={options => setCompoundpttions(options)}
                                            isMulti={true}

                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Unit Type*</label>
                                        <Select
                                            placeholder='Select'
                                            options={unitTypeOptions}
                                            noOptionsMessage={() => {
                                                if(formData.selectedCompound?.length === 0 || !formData.selectedCompound){
                                                    return "Choose compound first"
                                                } else{
                                                    return "No Choose"
                                                }
                                            }}
                                            onChange={(data) => setFormData({ ...formData, selectUnitType: data })}
                                            value={formData.selectUnitType}
                                            // Service={UnitTypesService}
                                            // setOptions={options => setUnitTypeOptions(options)}
                                            isMulti={true}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* Elevate Down Payment */}
                        <Card>
                            <CardBody>
                                <h5>Elevate Down Payment</h5>
                                <>
                                    {formData?.elevate_down_payment?.map((elevat, index)=> {
                                        return <Row className="mt-3" key={index}>
                                        <Col md={6} className='mb-3'>
                                            <AvField
                                                label={"Down Payment"}
                                                name={`elevate_down_payment${index}`}
                                                value={elevat.down_payment }
                                                type="number"
                                                onChange={e => {
                                                    let update = formData?.elevate_down_payment?.map((elev, ind)=> {
                                                        if(ind === index){
                                                            return {
                                                                ...elev,
                                                                down_payment: e.target.value
                                                            }
                                                        } else {
                                                            return elev
                                                        }
                                                    })
                                                    setFormData({ ...formData, elevate_down_payment: update })    
                                                }}
                                                placeholder={"between 1.0% and 100%"}
                                                min={"1"}
                                                max={"100"}
                                            />
                                        </Col>
                                        <Col md={index > 0 ? 5 : 6} className='mb-3'>
                                            <AvField
                                                name={`elevate_discount${index}`}
                                                label={"Discount"}
                                                value={elevat.discount}
                                                type="number"
                                                onChange={e => {
                                                    let update = formData?.elevate_down_payment?.map((elev, ind)=> {
                                                        if(ind === index){
                                                            return {
                                                                ...elev,
                                                                discount: e.target.value
                                                            }
                                                        } else {
                                                            return elev
                                                        }
                                                    })
                                                    setFormData({ ...formData, elevate_down_payment: update })     
                                                }}
                                                placeholder={"between 1.0% and 99.0% "}
                                                min={"1"}
                                                max={"99"}
                                            />
                                        </Col>
                                        {index > 0 && <Col md={1} className="d-flex justify-content-end align-items-center">
                                            <button
                                                className="btn btn-light mt-2"
                                                type="button"
                                                onClick={() => {
                                                    const updated = formData.elevate_down_payment.filter((_, ind) => ind !== index)
                                                    setFormData({ ...formData, elevate_down_payment: updated })
                                                }}
                                                style={{ color: "red", fontWeight: "700" }}
                                            >
                                                X
                                            </button>
                                        </Col>}
                                        </Row>
                                    })}
                                    <Button type="button" onClick={()=>{
                                        let update = [...formData?.elevate_down_payment, {down_payment: "", discount: ''} ]
                                        setFormData({ ...formData, elevate_down_payment: update }) 
                                    }}>
                                        Add Other Various Down Payment
                                    </Button>
                                </>
                            </CardBody>
                        </Card>

                        {/* Cash Discount */}
                        {/* <Card>
                            <CardBody>
                                <h5>Cash Discount</h5>
                                <Row className="mt-3">
                                    <Col md={6} className='mb-3'>
                                        <AvField
                                            label={"Down Payment"}
                                            
                                            name='cash'
                                            value={formData.cash }
                                            type="number"
                                            onChange={e => {
                                                setFormData({ ...formData, cash: e.target.value })    
                                            }}
                                            validate={{
                                                required: {value: true , errorMessage: 'This Field is Required'},
                                                pattern: {value: '/^[0-9 ]+$/' , errorMessage: `This Format is Invalid`}
                                            }}
                                            placeholder={"between 1.0% and 100%"}
                                            min={"1"}
                                            max={"100"}
                                        />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <AvField
                                            errorMessage="This Field is Required"
                                            name='discount'
                                            label={"Discount*"}
                                            
                                            value={formData.discount }
                                            type="number"
                                            required
                                            onChange={e => {
                                                setFormData({ ...formData, discount: e.target.value })    
                                            }}
                                            placeholder={"between 1.0% and 99.0% "}
                                            min={"1"}
                                            max={"99"}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card> */}

                        {/* Years Installemnt */}
                        {formData.years.map((year, index) => {
                            return (
                                <Card key={index} >
                                    <CardBody>
                                        {index >= 1 &&
                                            <Row className="d-flex justify-content-end">
                                                <Col md={6} className="d-flex justify-content-end">
                                                    <button
                                                        className="btn btn-light"
                                                        type="button"
                                                        onClick={() => {
                                                            const updatedYears = formData.years.filter((year, yearIndex) => yearIndex !== index)
                                                            setFormData({ ...formData, years: updatedYears })
                                                        }}
                                                        style={{ color: "red", fontWeight: "700" }}
                                                    >
                                                        X
                                                    </button>
                                                </Col>
                                            </Row>}
                                        <Row>
                                            <Col md={6} className="mb-3">
                                                <AvField
                                                    name={`years${index}`}
                                                    label={`Years Of Installment*`}
                                                    value={formData ?.years[index] ?.years}
                                                    onChange={e => {
                                                        const updatedYears = formData.years.map((year, yearindex) => {
                                                            if (index === yearindex){
                                                                year.years = e.target.value
                                                                if(year?.type?.value === "variable") year.recurring_payments = year.recurring_payments?.map(res=>{
                                                                    let update = {
                                                                        payment_frequency: res?.payment_frequency || '',
                                                                        payment_amount: new Array(Number(e.target.value)).fill("")
                                                                    }
                                                                    return update
                                                                }) 
                                                                if(year?.type?.value === "equal") year.recurring_payments = year.recurring_payments?.map(res=>{
                                                                    let update = {
                                                                        payment_frequency: res?.payment_frequency || '',
                                                                        payment_amount: !!res?.payment_frequency[0] ? [res?.payment_frequency[0]] : [""]
                                                                    }
                                                                    return update
                                                                }) 
                                                            }
                                                            return year
                                                        })
                                                        setFormData({ ...formData, years: updatedYears })
                                                    }}
                                                    required
                                                    errorMessage="This field is required"
                                                    placeholder={"Years 1-30"}
                                                    step="1"
                                                    pattern="\d+"
                                                    min="1"
                                                    type="number"
                                                    max="30"
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <label>Installment Type</label>
                                                <Select
                                                    placeholder='Select'
                                                    options={!formData?.years[index]?.years ? [] : installment_type}
                                                    noOptionsMessage={() => {
                                                        if(!formData?.years[index]?.years){
                                                            return "Enter Years of Installment first"
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        const updatedYears = formData.years.map((year, yearindex) => {
                                                            if (index === yearindex){
                                                                let update = {
                                                                    payment_frequency: "",
                                                                    payment_amount: e?.value === "variable" ? new Array(Number(year?.years)).fill("") : [""]
                                                                }
                                                                return {
                                                                    ...year,
                                                                    recurring_payments: year.recurring_payments?.map(_=> update),
                                                                    type: e
                                                                }
                                                            }
                                                            return year
                                                        })
                                                        setFormData({ ...formData, years: updatedYears })
                                                    }}
                                                    value={formData?.years[index]?.type}
                                                />
                                            </Col>
                                            <Col md={6} className="price-input">
                                                {/* <Label className={!!error[index]?.depost ? "error-text" :""}>Deposit (Optional)</Label> */}
                                                <Label>Deposit (Optional)</Label>
                                                <CurrencyInput
                                                    // className={!formData.years[index]?.depost && !!id ? "mb-0" :"mb-3"}
                                                    // style={{borderColor: !!error[index]?.depost && '#dc3545'}}
                                                    name={`depost${index}`}
                                                    id={`deposit_${index}`}
                                                    
                                                    minLength= {1}
                                                    value={!!formData.years[index]?.depost ? formData.years[index]?.depost : ''}
                                                    onValueChange={value=> {
                                                        const updatedYears = formData.years?.map((year, yearindex) => {
                                                            if (index === yearindex) year.depost = parseFloat(value)
                                                            return year
                                                        })
                                                        setFormData({ ...formData, years: updatedYears })
                                                        // setError((prev)=> ({...prev, [index]: {...error[index], depost: false}}))
                                                    }}
                                                    allowNegativeValue={false}
                                                    decimalsLimit={2}
                                                    // required
                                                    placeholder={"10,000 EGP e.g."}
                                                    min={"0"}
                                                />
                                                {/* {!!error[index]?.depost && <p className="error-text">This field is required</p>} */}
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <AvField
                                                    name={`down_payment${index}`}
                                                    id={`down_payment_${index}`}
                                                    label={"Down Payment"}
                                                    
                                                    value={formData.years[index].down_payment }
                                                    type="number"
                                                    required
                                                    onChange={e => {
                                                        const value = e.target.value
                                                        const updatedYears = formData.years.map((year, yearindex) => {
                                                            if (index === yearindex) year.down_payment = parseFloat(value)
                                                            return year
                                                        })
                                                        setFormData({ ...formData, years: updatedYears })
                                                    }}
                                                    placeholder={"1.234%  e.g."}
                                                    min={"0.000001"}
                                                    max={"99.99999"}
                                                />
                                            </Col>
                                        </Row>
                                        {year.recurring_payments.map((recurringPayment, recurringIndex) => {
                                            return (
                                                <Row className="my-3 mx-2 py-2 bg-light" key={recurringIndex}>
                                                    <Row className="pt-2 ">
                                                        <Col md={6}>
                                                            <h5>Recurring Payment</h5>
                                                        </Col>
                                                        {recurringIndex != 0 ? <Col md={6} className="d-flex justify-content-end my-2">
                                                            <button
                                                                className="btn btn-light"
                                                                type="button"
                                                                onClick={() => {
                                                                    const updatedYears = formData.years.map((year, yearIndex) => {
                                                                        if (index === yearIndex) {
                                                                            const updatedList = year.recurring_payments.filter((_, index) => index !== recurringIndex)
                                                                            year.recurring_payments = updatedList
                                                                            return year
                                                                        }
                                                                        return year
                                                                    })
                                                                    setFormData({ ...formData, years: updatedYears })
                                                                }}
                                                                style={{ color: "red", fontWeight: "700" }}
                                                            >
                                                                X
                                                                </button>
                                                        </Col> : null}
                                                    </Row>
                                                    <Col md={6}>
                                                        <label>Payment Frequency*</label>
                                                        <Select
                                                            placeholder={"Select"}
                                                            value={recurringPayment?.payment_frequency ? {
                                                                label: recurringPayment?.payment_frequency,
                                                                value: recurringPayment?.payment_frequency
                                                            } : null}
                                                            options={frequencyPropertyOptions.filter(({ label: l1 }) => !year.recurring_payments.some(({ payment_frequency: l2 }) => l2 === l1))}
                                                            className='mb-3'
                                                            onChange={(data) => {
                                                                const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                    if (elementIndex === index) {
                                                                        return {
                                                                            ...yearElemnet,
                                                                            recurring_payments: yearElemnet.recurring_payments.map((item, itemIndex) => {
                                                                                if (itemIndex === recurringIndex){
                                                                                    return {
                                                                                        ...item,
                                                                                        payment_frequency: data.value
                                                                                    }
                                                                                } 
                                                                                return item
                                                                            })
                                                                        }
                                                                    }
                                                                    return yearElemnet
                                                                })
                                                                setFormData({ ...formData, years: [...updatedYears] })
                                                            }}
                                                        />
                                                    </Col>
                                                    {year?.type?.value === "variable" && <Col md={6}></Col>}
                                                    {recurringPayment?.payment_amount?.map((key, value) => (
                                                        <Col md={6} className="mb-3">
                                                                <AvField
                                                                    name={`payment_${value}${recurringIndex}${index}`}
                                                                    label={
                                                                        (year?.type?.value === "equal" || !year?.type)? "Payment amount" :
                                                                        value === 0 ? "One Payment for the 1st year" : value === 1 ? 'One Payment for the 2nd year' :
                                                                        value === 2 ? 'One Payment for the 3rd year' : `One Payment for the ${value+1}th year` }
                                                                    value={key}
                                                                    onChange={e => {
                                                                        let val = e.target.value
                                                                        const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                            if (elementIndex === index) {
                                                                                return {
                                                                                    ...yearElemnet,
                                                                                    recurring_payments: yearElemnet.recurring_payments.map((item, itemIndex) => {
                                                                                        if (itemIndex === recurringIndex){
                                                                                            const updatedValues = [...item.payment_amount]; 
                                                                                            updatedValues[value] = Number(val);
                                                                                            return {
                                                                                                ...item,
                                                                                                payment_amount: updatedValues
                                                                                            }
                                                                                        } 
                                                                                        return item
                                                                                    })
                                                                                }
                                                                            }
                                                                            return yearElemnet
                                                                        })
                                                                        setFormData({ ...formData, years: [...updatedYears] })
                                                                    }}
                                                                    required
                                                                    errorMessage="This field is required"
                                                                    placeholder={"1.234%  e.g."}
                                                                    min={"0.000001"}
                                                                    max={"99.99999"}
                                                                    type="number"
                                                                />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            )
                                        })}
                                        {year.recurring_payments.length < 4 ?
                                            <Col md={12} className="d-flex justify-content-end my-2">
                                                <button
                                                    className="btn btn-light"
                                                    type="button"
                                                    onClick={() => {
                                                        const updatedYears = formData.years.map((year, yearIndex) => {
                                                            if (index === yearIndex) {
                                                                let update = {
                                                                    payment_frequency: ""
                                                                }
                                                                if(year?.type?.value === "variable") {
                                                                    update['payment_amount'] = new Array(Number(year?.years)).fill("")
                                                                } else {
                                                                    update['payment_amount'] = ['']
                                                                }
                                                                year.recurring_payments.push(update)
                                                            }
                                                            return year
                                                        })
                                                        setFormData({ ...formData, years: updatedYears })
                                                    }}
                                                >
                                                    Add New Recurring
                                                </button>
                                            </Col> : null}
                                        {year ?.off_payments ?.map((offItem, offIndex) => {
                                            return (
                                                <Row className="my-3 mx-2 py-2 bg-light" key={offIndex}>
                                                    <Row>
                                                        <Col md={6} className="my-2"><h5> {offIndex + 1} One-Off Payment</h5></Col>
                                                        <Col md={6} className="d-flex justify-content-end my-2">
                                                            <button
                                                                className="btn btn-light"
                                                                type="button"
                                                                onClick={() => {
                                                                    const updatedYears = formData.years.map((year, yearIndex) => {
                                                                        if (index === yearIndex) {
                                                                            const updatedList = year.off_payments.filter((_, index) => index !== offIndex)
                                                                            year.off_payments = updatedList
                                                                            return year
                                                                        }
                                                                        return year
                                                                    })
                                                                    setFormData({ ...formData, years: updatedYears })
                                                                }}
                                                                style={{ color: "red", fontWeight: "700" }}
                                                            >X</button></Col>

                                                    </Row>
                                                    <Col md={6} >
                                                        <AvField
                                                            className="mb-3"
                                                            name={`payment_name${index}${offIndex}`}
                                                            label={`Payment Name*`}
                                                            value={offItem?.payment_name}
                                                            onChange={e => {
                                                                const value = e.target.value
                                                                const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                    if (elementIndex === index) {
                                                                        yearElemnet.off_payments.map((item, itemIndex) => {
                                                                            if (itemIndex === offIndex) item.payment_name = value
                                                                            return item
                                                                        })
                                                                    }
                                                                    return yearElemnet
                                                                })
                                                                setFormData({ ...formData, years: [...updatedYears] })

                                                            }}
                                                            required
                                                            errorMessage="This field is required"
                                                            placeholder={"Payment Name"}
                                                        />
                                                    </Col>
                                                    <Col md={6}>
                                                        <label>Type of Paid</label>
                                                        <Select
                                                            placeholder='Select'
                                                            options={type_of_paid_options}
                                                            onChange={e => {
                                                                const value = e?.value
                                                                const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                    if (elementIndex === index) {
                                                                        return {
                                                                            ...yearElemnet,
                                                                            off_payments: yearElemnet.off_payments.map((item, itemIndex) => {
                                                                                if (itemIndex === offIndex){
                                                                                    return {
                                                                                        ...item,
                                                                                        type: value
                                                                                    }
                                                                                }
                                                                                return item
                                                                            })
                                                                        }
                                                                    }
                                                                    return yearElemnet
                                                                })
                                                                setFormData({ ...formData, years: [...updatedYears] })
                                                            }}
                                                            value={!!offItem?.type ? type_of_paid_options?.find(opt=> opt.value === offItem?.type) : ""}
                                                        />
                                                    </Col>
                                                    <Col md={6} className="mb-3 price-input">
                                                        <Label>Payment Fees*</Label>
                                                        {(offItem?.type === 'percentage' || offItem?.type === 'percentage_per_meter') ?
                                                        <AvField
                                                        name={`payment_fees${index}${offIndex}`}
                                                        value={parseFloat(offItem?.payment_fees)}
                                                        onChange={e => {
                                                            const value = e.target.value
                                                            const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                if (elementIndex === index) {
                                                                    yearElemnet.off_payments.map((item, itemIndex) => {
                                                                        if (itemIndex === offIndex) item.payment_fees = parseFloat(value)
                                                                        return item
                                                                    })
                                                                }
                                                                return yearElemnet
                                                            })
                                                            setFormData({ ...formData, years: [...updatedYears] })
                                                        }}
                                                        required
                                                        type="number"
                                                        min={"0.000001"}
                                                        max={"99.99999999"}
                                                        placeholder={"1.234% e.g."}
                                                        /> : <CurrencyInput
                                                            name={`payment_fees${index}${offIndex}`}
                                                            minLength= {1}
                                                            value={!!offItem?.payment_fees ? offItem?.payment_fees : ''}
                                                            onValueChange={e => {
                                                                const value = e//.target.value
                                                                const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                    if (elementIndex === index) {
                                                                        yearElemnet.off_payments.map((item, itemIndex) => {
                                                                            if (itemIndex === offIndex) item.payment_fees = parseFloat(value)
                                                                            return item
                                                                        })
                                                                    }
                                                                    return yearElemnet
                                                                })
                                                                setFormData({ ...formData, years: [...updatedYears] })
                                                            }}
                                                            allowNegativeValue={false}
                                                            decimalsLimit={2}
                                                            required
                                                            min={"0"}
                                                            max={"9"}
                                                            placeholder={"1 e.g"}
                                                        
                                                        />}
                                                    </Col>
                                                    <Col md={3} >
                                                        <AvField
                                                            className="mb-3"
                                                            label={`Year Number*`}
                                                            name={`year_number${index}${offIndex}`}
                                                            
                                                            value={offItem?.year_number}
                                                            onChange={e => {
                                                                const value = e.target.value
                                                                const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                    if (elementIndex === index) {
                                                                        yearElemnet.off_payments.map((item, itemIndex) => {
                                                                            if (itemIndex === offIndex) item.year_number = value
                                                                            return item
                                                                        })
                                                                    }
                                                                    return yearElemnet
                                                                })
                                                                setFormData({ ...formData, years: [...updatedYears] })

                                                            }}
                                                            required
                                                            type="number"
                                                            placeholder={"year number"}
                                                            errorMessage="This field is required"
                                                            min="1"
                                                            step="1"
                                                            pattern="\d+"
                                                            max={`${year.years}`}
                                                        />
                                                    </Col>
                                                    <Col md={3} >
                                                        <AvField
                                                            className="mb-3"
                                                            name={`month_number${index}${offIndex}`}
                                                            label={"Month Number*"}
                                                            
                                                            value={offItem?.month_number}
                                                            onChange={e => {
                                                                const value = e.target.value
                                                                const updatedYears = formData.years.map((yearElemnet, elementIndex) => {
                                                                    if (elementIndex === index) {
                                                                        yearElemnet.off_payments.map((item, itemIndex) => {
                                                                            if (itemIndex === offIndex) item.month_number = value
                                                                            return item
                                                                        })
                                                                    }
                                                                    return yearElemnet
                                                                })
                                                                setFormData({ ...formData, years: [...updatedYears] })
                                                            }}
                                                            required
                                                            type="number"
                                                            placeholder={"Month Number"}
                                                            errorMessage="This field is required"
                                                            step="1"
                                                            pattern="\d+"
                                                            min="1"
                                                            max="12"
                                                        />
                                                    </Col>
                                                    {offItem?.another?.length > 0 && offItem?.another?.map((anotherItem, anotherIndex)=>{
                                                        // if(offItem?.payment_name == anotherItem.payment_name){
                                                            return <Row className="mt-2" key={anotherIndex}>
                                                            <Col md={6} className="mb-3 price-input">
                                                                <Label>Payment Fees*</Label>
                                                                {(offItem?.type === 'percentage' || offItem?.type === 'percentage_per_meter') ?<AvField
                                                                    name={`payment_fees${index}${offIndex}${anotherIndex}`}
                                                                    value={anotherItem.payment_fees}
                                                                    onChange={e => {
                                                                        const value = !!e.target.value ? parseFloat(e.target.value) : ''
                                                                        const updatedAnother = formData.years.map((yearElemnet, elementIndex) => {
                                                                            if (elementIndex === index) {
                                                                                yearElemnet.off_payments.map((item, itemIndex) => {
                                                                                    if(itemIndex === offIndex){
                                                                                        item?.another?.map((_, anothIndex)=>{
                                                                                            if(anothIndex == anotherIndex){
                                                                                                item.another[anotherIndex].payment_fees = value
                                                                                            }
                                                                                        })
                                                                                    } else {
                                                                                        return item
                                                                                    }
                                                                                })
                                                                            }
                                                                            return yearElemnet
                                                                        })
                                                                        
                                                                        setFormData({ ...formData, years: updatedAnother })
                                                                    }}
                                                                    required
                                                                    type="number"
                                                                    min={"0.000001"}
                                                                    max={"99.99999"}
                                                                    placeholder={"1.234% e.g."}
                                                                /> : <CurrencyInput
                                                                    name={`payment_fees${index}${offIndex}`}
                                                                    minLength= {1}
                                                                    value={!!anotherItem.payment_fees ? anotherItem.payment_fees : ''}
                                                                    onValueChange={e => {
                                                                        const value = e //!!e.target.value ? parseFloat(e.target.value) : ''
                                                                        const updatedAnother = formData.years.map((yearElemnet, elementIndex) => {
                                                                            if (elementIndex === index) {
                                                                                yearElemnet.off_payments.map((item, itemIndex) => {
                                                                                    if(itemIndex === offIndex){
                                                                                        item?.another?.map((_, anothIndex)=>{
                                                                                            if(anothIndex == anotherIndex){
                                                                                                item.another[anotherIndex].payment_fees = parseFloat(value)
                                                                                            }
                                                                                        })
                                                                                    } else {
                                                                                        return item
                                                                                    }
                                                                                })
                                                                            }
                                                                            return yearElemnet
                                                                        })
                                                                        
                                                                        setFormData({ ...formData, years: updatedAnother })
                                                                    }}
                                                                    allowNegativeValue={false}
                                                                    decimalsLimit={2}
                                                                    required
                                                                    min={"0"}
                                                                    max={"9"}
                                                                    placeholder={"1 e.g"}
                                                                />}
                                                            </Col>
                                                            <Col md={3} className="mb-3">
                                                                <AvField
                                                                    label={`Year Number*`}
                                                                    name={`year_number${index}${offIndex}${anotherIndex}`}
                                                                    
                                                                    value={anotherItem.year_number}
                                                                    onChange={e => {
                                                                        const value = !!e.target.value ? parseFloat(e.target.value) : ''
                                                                        const updatedAnother = formData.years.map((yearElemnet, elementIndex) => {
                                                                            if (elementIndex === index) {
                                                                                yearElemnet.off_payments.map((item, itemIndex) => {
                                                                                    if(itemIndex === offIndex){
                                                                                        item?.another?.map((_, anothIndex)=>{
                                                                                            if(anothIndex == anotherIndex){
                                                                                                item.another[anotherIndex].year_number = value
                                                                                            }
                                                                                        })
                                                                                    } else {
                                                                                        return item
                                                                                    }
                                                                                })
                                                                            }
                                                                            return yearElemnet
                                                                        })
                                                                        
                                                                        setFormData({ ...formData, years: updatedAnother })
                                                                    }}
                                                                    required
                                                                    type="number"
                                                                    placeholder={"year number"}
                                                                    errorMessage="This field is required"
                                                                    min="1"
                                                                    step="1"
                                                                    pattern="\d+"
                                                                    max={`${year.years}`}
                                                                />
                                                            </Col>
                                                            <Col md={3} className="mb-3">
                                                                <AvField
                                                                    name={`month_number${index}${offIndex}${anotherIndex}`}
                                                                    label={"Month Number*"}
                                                                    
                                                                    value={anotherItem.month_number}
                                                                    onChange={e => {
                                                                        const value = !!e.target.value ? parseFloat(e.target.value) : ''
                                                                        const updatedAnother = formData.years.map((yearElemnet, elementIndex) => {
                                                                            if (elementIndex === index) {
                                                                                yearElemnet.off_payments.map((item, itemIndex) => {
                                                                                    if(itemIndex === offIndex){
                                                                                        item?.another?.map((_, anothIndex)=>{
                                                                                            if(anothIndex == anotherIndex){
                                                                                                item.another[anotherIndex].month_number = value
                                                                                            }
                                                                                        })
                                                                                    } else {
                                                                                        return item
                                                                                    }
                                                                                })
                                                                            }
                                                                            return yearElemnet
                                                                        })
                                                                        
                                                                        setFormData({ ...formData, years: updatedAnother })
                                                                    }}
                                                                    required
                                                                    type="number"
                                                                    placeholder={"Month Number"}
                                                                    errorMessage="This field is required"
                                                                    step="1"
                                                                    pattern="\d+"
                                                                    min="1"
                                                                    max="12"
                                                                />
                                                            </Col>
                                                            
                                                            <button onClick={()=>{
                                                                    const updatedYears = formData.years.map((year, yearIndex) => {
                                                                        if (index === yearIndex) {
                                                                            year.off_payments.map((off, offInd)=>{
                                                                                if(offIndex == offInd){
                                                                                    const updatedList = off?.another.filter((_, filterIndex) => filterIndex !== anotherIndex)
                                                                                    off.another = updatedList
                                                                                }
                                                                            })
                                                                        }
                                                                        return year
                                                                    })
                                                                    setFormData({ ...formData, years: updatedYears })
                                                                }}
                                                                type='button'
                                                                style= {{position: "absolute", right: "0",
                                                                    width: "1rem", fontSize: "1rem",
                                                                    top: "52%", transform: "translate(0px, -45%)",
                                                                    fontWeight: "600" }}
                                                                 className='error-text btn delete'>
                                                                X
                                                            </button>
                                                        </Row>
                                                        // }
                                                    })}
                                                    
                                                    <Row className="mt-2">
                                                        <Col className="d-flex flex-row-reverse mb-2 mx-2">
                                                            <span 
                                                                style={{fontWeight: '600' }}
                                                                className="addAnotherYearAndMonth"
                                                                onClick={() => {
                                                                    // if(!offItem?.payment_name){
                                                                    //     toast.error('Enter Payment Name First')
                                                                    //     return
                                                                    // }
                                                                    const updatedYears = formData.years.map((year, yearIndex) => {
                                                                        if (index === yearIndex) {
                                                                            year.off_payments.map((off, offInd)=>{
                                                                                if(offIndex == offInd){
                                                                                    let newRow = {
                                                                                        payment_fees: "",
                                                                                        year_number: "",
                                                                                        month_number: ""
                                                                                    }
                                                                                    if(year.off_payments[offInd]['another']?.length){
                                                                                        year.off_payments[offInd]['another'].push(newRow)
                                                                                    } else{
                                                                                        year.off_payments[offInd]['another']=[newRow]
                                                                                    }
                                                                                }
                                                                                
                                                                            })
                                                                            
                                                                        }
                                                                        return year
                                                                    })
                                                                    setFormData({ ...formData, years: updatedYears })

                                                                    // let ind = anotherOffPayment[index]?.length
                                                                    // let item = !anotherOffPayment[index]?.length ? [] : [...anotherOffPayment[index]]
                                                                    // setAnotherOffPayment({...anotherOffPayment, [index]: [...item,{
                                                                    //     payment_name: offItem.payment_name,
                                                                    //     id: ind,
                                                                    //     payment_fees: "",
                                                                    //     year_number: "",
                                                                    //     month_number: ""
                                                                    // }] })
                                                                }}> 
                                                                <img src={AppoinmentsSvg} style={{ marginRight: "8px"}} />
                                                                Add another year&month</span>
                                                        </Col>
                                                    </Row>
                                                </Row>
                                            )
                                        })}
                                        <Row>
                                            <Col className="d-flex flex-row-reverse mt-4 mx-2">
                                                <Button
                                                    onClick={() => {
                                                        const updatedYears = formData.years.map((year, yearIndex) => {
                                                            if (index === yearIndex) {
                                                                year.off_payments.push({
                                                                    payment_name: "",
                                                                    payment_fees: "",
                                                                    type: "",
                                                                    year_number: "",
                                                                    month_number: ""
                                                                })
                                                            }
                                                            return year
                                                        })
                                                        setFormData({ ...formData, years: updatedYears })
                                                    }}> Add One-Off Payment</Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="d-flex flex-column align-items-end mt-4 mx-2">
                                                <label style={{display: 'contents'}}>
                                                    Link Various Down Payments to This Year
                                                    <div className='form-check form-switch form-switch-md mb-1'>
                                                        <input
                                                            name={`status${index}`}
                                                            checked={year?.link_down_payment}
                                                            type='checkbox'
                                                            className='form-check-input'
                                                            onChange={(e)=>{
                                                                const value = e.target.checked
                                                                let update = formData.years.map((ye, ind) => {
                                                                    if(index === ind){
                                                                        return {
                                                                            ...ye,
                                                                            link_down_payment: value
                                                                        }
                                                                    } else {
                                                                        return ye
                                                                    }
                                                                })
                                                                setFormData({
                                                                    ...formData,
                                                                    years: update
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                </label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            )
                        })}
                        <Row className="my-2 mx-2">
                            <Col className="d-flex justify-content-end">
                                <button
                                    className="btn text-success btn-hover font-size-14" type="button" onClick={() => {
                                        setFormData({
                                            ...formData,
                                            years: [...formData.years, {
                                                years: "",
                                                down_payment: "",
                                                recurring_payments: [{
                                                    payment_frequency: null,
                                                    payment_amount: [""]
                                                }],
                                                off_payments: [],
                                                depost: '',
                                                link_down_payment: false
                                            }]
                                        })
                                    }}><i className="fas fa-plus-circle"></i>&nbsp;Add new Payment Year</button>
                            </Col>
                        </Row>
                        <Row className="my-3 d-flex justify-content-between">
                            <Col>
                                <button
                                    type="button"
                                    className="btn btnUpload btnHeight px-4"
                                    onClick={() => { setModal(true) }}
                                    size={"lg"}
                                >
                                    Cancel
                                    </button>
                            </Col>
                            <Col className="d-flex justify-content-end">
                                <button
                                    type="submit"
                                    className="btn btn-success btnHeight"
                                    disabled={loading ? true : false}

                                >Submit</button>
                            </Col>
                        </Row>
                        <CancelModal
                            modal={modal}
                            setModal={setModal}
                            goBackHandler={() => {
                                if(filterData?.compound_id){
                                    props.history.push(`${adminPrefix}/payment-plan/${filterData?.compound_id}`)
                                } else{
                                    props.history.push(`${adminPrefix}/payment-plan`)
                                }
                            }} />
                        <SuccessModal
                            title={id ? "Edit Payment Plan" : "Add New Payment Plan"}
                            modal={successModal}
                            message={id ? "Payment Plan Edited Successfully" : "New Payment Plan Added Successfully"}
                            onClick={() => {
                                if(filterData?.compound_id){
                                    props.history.push(`${adminPrefix}/payment-plan/${filterData?.compound_id}`)
                                } else{
                                    props.history.push(`${adminPrefix}/payment-plan`)
                                }
                            }} />
                    </AvForm>
                </Container>
            </div>
        </React.Fragment>
    )
}

const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
      return formatter.format(number);
}

export default AddPayment